module.exports = __webpack_public_path__ + "public/img/fx.6b06b620.png";